import Icon from "./IconBase.js";
const NoSearchIcon = (props) => {
  return (
    <Icon width="85" height="84" viewBox="0 0 100 100" {...props}>
      <svg
        width="89"
        height="87"
        viewBox="0 0 89 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.3054 68.3052C53.807 68.3052 68.8054 53.3067 68.8054 34.8052C68.8054 16.3036 53.807 1.30518 35.3054 1.30518C16.8039 1.30518 1.80542 16.3036 1.80542 34.8052C1.80542 53.3067 16.8039 68.3052 35.3054 68.3052Z"
          fill="#F3F7FF"
          stroke="#00B0F5"
          strokeWidth="2.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.9375 60.7991C31.6962 61.1237 33.4855 61.2924 35.3054 61.3052C49.941 61.3052 61.8054 49.4407 61.8054 34.8052C61.8054 20.1696 49.941 8.30518 35.3054 8.30518C31.5458 8.30518 27.969 9.0881 24.7292 10.4998C19.0993 12.953 14.487 17.3051 11.7014 22.7471C9.84993 26.3641 8.80542 30.4627 8.80542 34.8052C8.80542 38.7452 9.66527 42.4844 11.2076 45.8453C12.3086 48.2448 13.7576 50.4514 15.4898 52.4008"
          fill="white"
        />
        <path
          d="M29.9375 60.7991C31.6962 61.1237 33.4855 61.2924 35.3054 61.3052C49.941 61.3052 61.8054 49.4407 61.8054 34.8052C61.8054 20.1696 49.941 8.30518 35.3054 8.30518C31.5458 8.30518 27.969 9.0881 24.7292 10.4998C19.0993 12.953 14.487 17.3051 11.7014 22.7471C9.84993 26.3641 8.80542 30.4627 8.80542 34.8052C8.80542 38.7452 9.66527 42.4844 11.2076 45.8453C12.3086 48.2448 13.7576 50.4514 15.4898 52.4008"
          stroke="#00B0F5"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M18.6028 55.3799C20.7509 57.1259 23.1777 58.5422 25.8062 59.5518"
          stroke="#00B0F5"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M62.8054 61.3052L68.8054 67.3052"
          stroke="#00B0F5"
          strokeWidth="2.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.8358 66.3356C65.9431 68.2283 65.9431 71.297 67.8358 73.1897L78.9211 84.275C80.8138 86.1677 83.8825 86.1677 85.7752 84.275C87.6679 82.3823 87.6679 79.3136 85.7752 77.4208L74.6899 66.3356C72.7972 64.4428 69.7285 64.4428 67.8358 66.3356Z"
          fill="#E8F0FE"
          stroke="#00B0F5"
          strokeWidth="2.5"
        />
        <path
          d="M72.8054 68.3052L83.8054 79.3052"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.8054 23.3052C28.8054 34.9032 38.2075 44.3052 49.8055 44.3052C52.0838 44.3052 54.2774 43.9424 56.3316 43.2714C52.9786 51.5923 44.828 57.4659 35.3054 57.4659C22.7903 57.4659 12.6448 47.3204 12.6448 34.8052C12.6448 23.4648 20.9751 14.07 31.8505 12.4062C29.9184 15.5845 28.8054 19.3149 28.8054 23.3052Z"
          fill="#E5F6FF"
        />
        <path
          d="M35.8054 16.3052C34.532 16.3052 33.2879 16.4304 32.0847 16.6693M28.4502 17.7813C21.6093 20.656 16.8054 27.4196 16.8054 35.3052"
          stroke="#00B0F5"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
};
export default NoSearchIcon;
